import { OAuthExtension } from '@magic-ext/oauth';
import { Magic as MagicBase } from 'magic-sdk';
import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { chainID, magicRPC } from '../app.config';
import { useNavigate, useLocation } from 'react-router-dom';
import userStatusMonitor from '../services/UserStatusMonitor';

export type Magic = MagicBase<OAuthExtension[]>;

type MagicContextType = {
  magic: Magic | null;
};

const MagicContext = createContext<MagicContextType>({
  magic: null,
});

export const useMagic = () => useContext(MagicContext);

const MagicProvider = ({ children }: { children: ReactNode }) => {
  const [magic, setMagic] = useState<Magic | null>(null);

  const navigate = useNavigate();
  const pathname = useLocation().pathname;

  const handleGetUserIfLoggedIn = async () => {
    try {
      const isLoggedIn = await magic?.user.isLoggedIn();
      if (!isLoggedIn) {
        // Stop monitoring when user is logged out
        userStatusMonitor.stopMonitoring();
        localStorage.clear();
        sessionStorage.clear();
        if (!pathname.includes('compare-doc')) {
          navigate('/');
        }
      }
    } catch (err: any) {}
  };

  useEffect(() => {
    if (process.env.REACT_APP_MAGIC_API_KEY) {
      const _magic = new MagicBase(
        process.env.REACT_APP_MAGIC_API_KEY as string,
        {
          network: {
            rpcUrl: magicRPC!,
            chainId: +chainID!,
          },
          extensions: [new OAuthExtension()],
          deferPreload: true,
        }
      );

      // _magic.user.revealPrivateKey();

      setMagic(_magic);
      // Set Magic instance in the user status monitor
      userStatusMonitor.setMagicInstance(_magic);
      //   setWeb3(new Web3((_magic as any).rpcProvider));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (magic) {
      handleGetUserIfLoggedIn();
    }
    // eslint-disable-next-line
  }, [magic]);

  const value = useMemo(() => {
    return {
      magic,
    };
  }, [magic]);

  return (
    <MagicContext.Provider value={value}>{children}</MagicContext.Provider>
  );
};

export default MagicProvider;
